module.exports = __webpack_public_path__ + "img/Shopp2.b99ed999.png";